var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"m-loading"},[_c('a-spin',{staticClass:"spin"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }